import { Directive } from '@angular/core';

@Directive({
  selector: '[appTextFieldTextWidth]'
})
export class TextFieldTextWidthDirective {

  constructor() { }

}
